<template>
  <div class="movie-app__container movie-app__pt-4 movie-app__pb-4">
    <div class="movie-app__row">
      <div class="movie-app__col-xs-12">
        <h1 class="movie-app__text-center movie-app__font_2">Kinoprogramm</h1>
        <p class="movie-app__text-center movie-app__font_sub_headline">Aktuelle Filme in München</p>
      </div>
    </div>
  </div>
  <PosterSlider/>

  <TabsWrapper>
    <Tab title="Kino"><CinemaList/></Tab>
    <Tab title="Filme"><MovieList/></Tab>
  </TabsWrapper> 
</template>

<script>
import PosterSlider from '../components/PosterSlider.vue'
import CinemaList from '../components/CinemaList.vue'
import MovieList from '../components/MovieList.vue'
import Tab from '../components/Tab.vue'
import TabsWrapper from '../components/TabsWrapper.vue' 

export default {
  components: { PosterSlider, CinemaList, MovieList, Tab, TabsWrapper}
}

</script>
